import React from "react";
import {Caption, Image, ImageContainer, StandardImageWrapper} from "./";

export const StandardImage = ({src, byline}) => {
    return (
        <ImageContainer>
            <StandardImageWrapper>
                <Image bgImage={src} useAspectRatio={true}/>
            </StandardImageWrapper>
            {byline && <Caption byline={byline}/>}
        </ImageContainer>
    );
};
